import styled from 'styled-components'
import useTranslation from '../../hooks/useTranslation'
import DetailViewLinesCard from './DetailVievLineCard'
import React from 'react'

const LinesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-left: 1rem;
`

/**
 * DetailViewLines Component
 * 
 * Displays nested line items (e.g., balance modifiers) within a detail card.
 * Each line shows an optional icon, content groups, and action buttons.
 * 
 * Props:
 * - config: Configuration object with:
 *   - array: Property name in parent item that contains the lines array
 *   - icon: Optional icon component to display in a circle
 *   - group: Array of field group configurations
 *   - actions: Array of action button configurations
 * - item: The parent detail item containing the lines array
 * - onAction: Handler function for action buttons, receives (action, item, line)
 */
const DetailViewLines = ({ config, item, onAction }) => {
    const { t } = useTranslation()

    if (!config || !item) return null

    const linesArray = item[config.array] || []
    if (linesArray.length === 0) return null

    return (
        <LinesContainer>
            {linesArray.map((line, lineIndex) => (
                <React.Fragment key={line.id || lineIndex}>
                    <DetailViewLinesCard config={config} item={item} line={line} onAction={onAction} />
                </React.Fragment>
            ))}
        </LinesContainer>
    )
}

export default DetailViewLines
